import axios from "axios";
import { API_URL } from "./index";
class FilmReleaseAssociationTypeService {
    getAll = () => {
        const url = API_URL.filmReleaseAssociationType();
        return axios.get(url).then((response) => response);
    };
}

export default new FilmReleaseAssociationTypeService();
